import React from 'react';
import { IconProps } from '.';

const SvgArrowStick = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2.4 9.6h19.2v4.8H2.4z' />
    </svg>
  );
};

export default SvgArrowStick;
